import ActionType from './ActionType';
import { ModelType } from '../Models/Mesh';
import Feature from 'ol/Feature';
import { customDateTimeFormat } from '../components/utils';

export const minDate = "1970-01-01";
export const maxDate = "2030-12-31";
export const initialMeshState: MeshState = {
  meshName: '',
  features: null,
  modelType: ModelType.MIKE21,
  meshProjection: null,
  meshProjectionWKT: null,
  meshProjectionShortname: null,
  meshTileGridConfig: null,
  meshTileGridProcess: false,
  extractionStartDate: localStorage.getItem('extractionStartDate')
    ? localStorage.getItem('extractionStartDate')
    : customDateTimeFormat(new Date(minDate)),
  extractionEndDate: localStorage.getItem('extractionEndDate')
    ? localStorage.getItem('extractionEndDate')
    : customDateTimeFormat(new Date(maxDate)),
  extractionPeriod: localStorage.getItem('extractionPeriod')
    ? localStorage.getItem('extractionPeriod')
    : new Date("1970-01-01").toISOString() + ' - ' + new Date("2030-12-31").toISOString(),
  extractionInitialDate: localStorage.getItem('extractionInitialDate')
    ? localStorage.getItem('extractionInitialDate')
    : null,
  extractionInitialPeriod: localStorage.getItem('extractionInitialPeriod')
    ? localStorage.getItem('extractionInitialPeriod')
    : '',
  saveForcingsInNativeGridResolution: true,
  extrapolateSpatialGaps: true,
  seaLevelAdjustment: 0.0,
};

export interface MeshState {
  meshName: string;
  features: Feature[]; // object[];
  modelType: ModelType;
  meshProjection: string;
  meshProjectionWKT: string;
  meshProjectionShortname: string;
  meshTileGridConfig: object[];
  meshTileGridProcess: boolean;
  extractionPeriod: string;
  extractionStartDate: string | null;
  extractionEndDate: string | null;
  extractionInitialDate: string | null;
  extractionInitialPeriod: string;
  saveForcingsInNativeGridResolution: boolean;
  extrapolateSpatialGaps: boolean;
  seaLevelAdjustment: number;
}

export type meshAction =
  | { type: ActionType.SET_MESH_NAME; data: string }
  | { type: ActionType.SET_MESH_FEATURES; data: object }
  | { type: ActionType.SET_MESH_MODEL_TYPE; data: ModelType }
  | { type: ActionType.SET_MESH_PROJECTION; data: string }
  | { type: ActionType.SET_MESH_PROJECTION_WKT; data: string }
  | { type: ActionType.SET_MESH_PROJECTION_SHORTNAME; data: string }
  | { type: ActionType.SET_MESH_TILEGRID_CONFIG; data: object }
  | { type: ActionType.SET_MESH_TILEGRID_PROCESS; data: boolean }
  | { type: ActionType.SET_EXTRACTION_PERIOD; data: string }
  | { type: ActionType.SET_EXTRACTION_STARTDATE; data: string }
  | { type: ActionType.SET_EXTRACTION_ENDDATE; data: string }
  | { type: ActionType.SET_EXTRACTION_INITIALDATE; data: string }
  | { type: ActionType.SET_EXTRACTION_INITIAL_PERIOD; data: string }
  | { type: ActionType.SET_SAVE_FORCINGS_IN_NATIVE_GRID_RESOLUTION; data: boolean }
  | { type: ActionType.SET_EXTRAPOLATE_SPATIAL_GAPS; data: boolean }
  | { type: ActionType.SET_EXTTRACTION_SEA_LEVEL_ADJUSTMENT; data: number };

export const meshReducer = (state: MeshState, action: meshAction) => {
  switch (action.type) {
    case ActionType.SET_MESH_NAME:
      return { ...state, meshName: action.data };

    case ActionType.SET_MESH_FEATURES:
      return { ...state, features: action.data };

    case ActionType.SET_MESH_MODEL_TYPE:
      return { ...state, modelType: action.data };

    case ActionType.SET_MESH_PROJECTION:
      return { ...state, meshProjection: action.data };

    case ActionType.SET_MESH_PROJECTION_WKT:
      return { ...state, meshProjectionWKT: action.data };

    case ActionType.SET_MESH_PROJECTION_SHORTNAME:
      return { ...state, meshProjectionShortname: action.data };

    case ActionType.SET_MESH_TILEGRID_CONFIG:
      return { ...state, meshTileGridConfig: action.data, meshTileGridProcess: false };

    case ActionType.SET_MESH_TILEGRID_PROCESS:
      return { ...state, meshTileGridProcess: true };

    case ActionType.SET_EXTRACTION_STARTDATE:
      localStorage.setItem('extractionStartDate', action.data);
      return { ...state, extractionStartDate: action.data };

    case ActionType.SET_EXTRACTION_ENDDATE:
      localStorage.setItem('extractionEndDate', action.data);
      return { ...state, extractionEndDate: action.data };

    case ActionType.SET_EXTRACTION_PERIOD:
      localStorage.setItem('extractionPeriod', action.data);
      return { ...state, extractionPeriod: action.data };

    case ActionType.SET_EXTRACTION_INITIALDATE:
      localStorage.setItem('extractionInitialDate', action.data);
      return { ...state, extractionInitialDate: action.data };

    case ActionType.SET_EXTRACTION_INITIAL_PERIOD:
      localStorage.setItem('extractionInitialPeriod', action.data);
      return { ...state, extractionInitialPeriod: action.data };

    case ActionType.SET_SAVE_FORCINGS_IN_NATIVE_GRID_RESOLUTION:
      return { ...state, saveForcingsInNativeGridResolution: action.data };

    case ActionType.SET_EXTRAPOLATE_SPATIAL_GAPS:
      return { ...state, extrapolateSpatialGaps: action.data };

    case ActionType.SET_EXTTRACTION_SEA_LEVEL_ADJUSTMENT:
      return { ...state, seaLevelAdjustment: action.data };

    default:
      return state;
  }
};
